import { Pipe, PipeTransform } from '@angular/core';
import { RefdataService, Company } from './refdata.service';

@Pipe({
  name: 'refdata',
  pure: false
})
export class RefdataPipe implements PipeTransform {

  private outputValue: string | string[] = null;

  constructor(private refdata: RefdataService) {
  }

  transform(value: string | string[], rdType: string): string | string[] {
    this.refdata.getRefdata().subscribe(rd => {
      let values: any[];
      this.outputValue = value;
      switch (rdType) {
        case 'accounttype': values = rd.accounttype; break;
        
        
        default: {
          values = rd[rdType];
          if (!values) {
            console.error('unknown refdata type ' + rdType);
          }
        }
      }
      if (values) {
        if (typeof value === 'string') {
          for (const v of values) {
            if (v.key === value) {
              this.outputValue = v.label;
            }
          }
        }
        else if (Array.isArray(value)) {
          this.outputValue = value.map(item => {
            for (const v of values) {
              if (v.key === item) {
                return this.outputValue = v.label;
              }
            }
            return item;
          }).join(', ');
        }
      }
    });
    return this.outputValue;
  }
}
